import React from 'react';
import { useNavigate } from 'react-router-dom';
import CountUp from 'react-countup';
import styles from './KPICard.module.scss';
import LoadingSkeleton from './LoadingSkeleton';

export default function KPICard({
  title,
  value,
  change,
  icon: Icon,
  color = 'var(--mh-primary, #644998)',
  onClick,
  to,
  loading,
}) {
  const navigate = useNavigate();
  const numeric = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^0-9.-]/g, ''));
  const isNum = !Number.isNaN(numeric);

  const handleClick = () => {
    if (to) navigate(to);
    if (onClick) onClick();
  };

  const clickable = Boolean(to || onClick);

  if (loading) {
    return (
      <div className={styles.card}>
        <LoadingSkeleton rows={3} cols={1} />
      </div>
    );
  }

  const trendUp = change == null ? null : change >= 0;

  return (
    <div
      className={`${styles.card} ${clickable ? styles.clickable : ''}`}
      onClick={clickable ? handleClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick();
              }
            }
          : undefined
      }
    >
      <div className={styles.top}>
        <div>
          <div className={styles.value}>
            {isNum ? <CountUp end={numeric} duration={0.8} preserveValue /> : value}
          </div>
          <div className={styles.title}>{title}</div>
        </div>
        {Icon && (
          <div className={styles.iconWrap} style={{ backgroundColor: color }}>
            <Icon size={20} />
          </div>
        )}
      </div>
      {change != null && (
        <div className={`${styles.trend} ${trendUp ? styles.up : styles.down}`}>
          {trendUp ? '▲' : '▼'} {Math.abs(change)}%
        </div>
      )}
    </div>
  );
}
